export default "__VITE_ASSET__XX3wIzsi__";